import { motion } from "framer-motion";
import { GALLERY } from "@/lib/siteData";

export default function Gallery() {
  return (
    <section id="gallery" className="relative bg-ink/70 py-24 md:py-36" data-testid="gallery-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-brass">/ Inventory & Craft</span>
            <h2 className="mt-5 font-display uppercase leading-[0.9] tracking-tighter text-5xl md:text-7xl">
              On The <span className="text-stroke">Rack</span>
            </h2>
          </div>
          <p className="max-w-sm font-body text-bone/60 leading-relaxed">
            A rotating look at rifles, handguns, ammo, and custom work moving through the shop. Stock changes weekly.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 auto-rows-[200px] md:auto-rows-[240px] gap-3 md:gap-4">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.05 }}
              data-testid={`gallery-item-${i}`}
              className="group relative overflow-hidden border border-steel bg-coal"
            >
              <img
                src={g.url}
                alt={g.label}
                loading="lazy"
                className="w-full h-full object-cover saturate-[1.15] scale-105 group-hover:scale-100 group-hover:saturate-150 transition-all duration-700 ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/10 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-300" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-4 flex items-center justify-between">
                <span className="font-display uppercase text-sm md:text-base tracking-tight text-bone">
                  {g.label}
                </span>
                <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-brass border border-brass/40 px-2 py-1">
                  {g.tag}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
